import { Grid, GridItem } from "@chakra-ui/react";
import { EnvelopeIcon } from "lib/icons/envelope";
import { PhoneIcon } from "lib/icons/phone";
import { useAppSelector } from "lib/redux";
import { FC, useState } from "react";
import { selectBio } from "./creatorCardSlice";
import { Field } from "./types";
import { TextImage } from 'components/controls/text-image';

type Props = { 
  contactKey: string;
}

const contactIcons = {
  [Field.email]: EnvelopeIcon,
  [Field.phone]: PhoneIcon,
};

const extensions = {
  [Field.email]: 'mailto:',
  [Field.phone]: 'tel:'
};

const openLink = (href: string) => {
  const aTag = document.createElement('a');
  aTag.rel = 'noopener';
  aTag.href = href;
  aTag.click();
}

export const CreatorCardContactLink: FC<Props> = ({ contactKey }) => {
  const bio = useAppSelector(selectBio);
  const [ show, setShow ] = useState<boolean>(false);

  const Icon = contactIcons[contactKey];
  const href = extensions[contactKey] + bio[contactKey];

  if (!Icon) {
    return (
      <a color="inherit" onMouseOver={() => setShow(true)} onClick={() => openLink(href)} title={contactKey} style={{cursor: 'pointer'}}>
        <TextImage text={bio[contactKey]} show={show} />
      </a>
    );
  }

  return (
    <a color="inherit" onMouseOver={() => setShow(true)} onClick={() => openLink(href)} title={contactKey} style={{cursor: 'pointer'}}>
      <Grid gap="10px" autoFlow="column">
        <GridItem><Icon boxSize="20px" /></GridItem>
        <GridItem><TextImage text={bio[contactKey]} show={show} /></GridItem>
      </Grid>
    </a>
  )
};